import styled, { css } from 'styled-components';
import { FONT_COLOURS, FONT_WEIGHT, getHeadingFont, textShimmer } from '@belong/themes';
import { FontSizeHeadingKey, HeadingElements } from '@belong/types';
import { Text } from '../Text';
import { IDisplay } from './Display.types';

// TODO: Eliminate the use of heading level to determine font style. This is a semantic error
const getAsPropFromProps = ({ isSmall }: IDisplay): Extract<HeadingElements, 'h1' | 'h2'> => {
  return isSmall ? 'h2' : 'h1';
};

/**
 * @deprecated Use `Heading` instead
 */
export const Display = styled(Text).attrs<IDisplay>(props => ({
  hasColor: props.hasColor,
  as: props.as || getAsPropFromProps(props)
}))<IDisplay>`
  font-weight: ${FONT_WEIGHT.BOLD};
  overflow-wrap: anywhere;

  ${({ isSmall }) => {
    const headingSize: FontSizeHeadingKey = isSmall ? 'xlarge' : 'xxlarge';
    return css`
      ${getHeadingFont(headingSize)}
    `;
  }}

  ${({ hasColor }) => (hasColor === FONT_COLOURS.LIGHT ? textShimmer : '')};

  color: ${({ hasColor, theme }) =>
    hasColor === FONT_COLOURS.LIGHT
      ? 'transparent'
      : theme.foregroundColorDark}; // use the theme color when present or transparent for shimmer affected
`;
